import React, { useContext, useEffect, useState } from "react";
import { TranslatorContext } from "../../../context/Translator";
import { Link } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import PageLayout from "../../../layouts/PageLayout";
import TrainingTableComponent from "../../../components/tables/TrainingTableComponent";
import axios from "axios";

export default function Trainings() {
  const { t } = useContext(TranslatorContext);
  const [trainings, setTrainings] = useState([]);
  const AuthToken = localStorage.getItem("AuthUser");
  axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;
  useEffect(() => {
    const fetchTrainings = async () => {
      try {
        const res = await axios.get(process.env.REACT_APP_API_URL + "/vocational-trainings");
        setTrainings(
          res.data.data.map((t) => ({
            id: t.id, // adjust if you want real Family+Name
            f_number: t.f_number, // adjust if you want real Family+Name
            children_name: t.children_id,   // or fetch related child name if relation exists
            institute_name: t.institute_name,
            training_name: t.training_name,
            training_duration: t.duration,
            total_fees: t.fee,
            status: t.completed ? "Completed" : "Ongoing",
            action: { edit: "edit", delete: "delete" }
          }))
        );
      } catch (err) {
        console.error(err);
      }
    };

    fetchTrainings();
  }, []);

  return (
    <PageLayout>
      <Row>
        <Col xl={12}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">{"All Trainings"}</h3>
              <ul className="mc-breadcrumb-list">
                <li className="mc-breadcrumb-item">
                  <Link to="#" className="mc-breadcrumb-link">
                    {t("home")}
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">
                  <Link to="#" className="mc-breadcrumb-link">
                    {t("Vocational Trainings")}
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">{"All Trainings List"}</li>
              </ul>
            </div>
          </div>
        </Col>

        <Col xl={12}>
          <div className="mc-card">
            <Row>
              <Col xl={12}>
                <TrainingTableComponent
                  thead={[
                    "Family",
                    "Children's Name",
                    "Institute's Name",
                    "Training Name",
                    "Training Duration",
                    "Total Fees",
                    "Status",
                    // "Actions"
                  ]}
                  tbody={trainings}
                />
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </PageLayout>
  );
}
